import { createContext } from 'react';

const MediaQueryContext = /*#__PURE__*/createContext(undefined);

export { MediaQueryContext };
